import script from "./KriMetricsList.vue?vue&type=script&lang=ts&setup=true"
export * from "./KriMetricsList.vue?vue&type=script&lang=ts&setup=true"

import "./KriMetricsList.vue?vue&type=style&index=0&id=03e65408&lang=scss"

const __exports__ = script;

export default __exports__